// src/js/config/urlParamHandler.js

import { DOMElements } from './dom.js';
import { applyTier } from './configFormHandler.js';

// TODO: När data-genereringen refaktoreras, ska basePrices importeras här.

/**
 * Privat funktion som hanterar "?package=<tierName>" parametern.
 * @param {URLSearchParams} urlParams - De aktiva URL-parametrarna.
 */
function handlePackageParam(urlParams) {
    try {
        const packageFromUrl = urlParams.get('package');
        if (!packageFromUrl) return; // Ingen parameter, gör inget.

        // Hämta tillgängliga paket-nivåer från den globala datan
        const basePrices = window.SimP?.DATA?.basePrices || {};
        const validTiers = Object.keys(basePrices);

        // Hitta det korrekta namnet (hanterar skiftlägeskänslighet, t.ex. "pro" vs "Pro")
        const correctTierName = validTiers.find(tier => tier.toLowerCase() === packageFromUrl.toLowerCase());

        if (correctTierName) {
            applyTier(correctTierName); // Anropa vår migrerade funktion!
        } else {
            console.warn(`Ogiltigt paket specificerat i URL: "${packageFromUrl}"`);
        }
    } catch (error) {
        console.error("Fel vid hantering av 'package' URL-parameter:", error);
    }
}

/**
 * Processar alla kända URL-parametrar. Denna funktion anropas sist vid sidladdning.
 */
export function processUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);

    // Kör endast logik om vi är på konfiguratör-sidan
    if (DOMElements.configPage) {
        handlePackageParam(urlParams);
    }

    // Här kan logik för andra sidor (t.ex. orderPage) läggas till i framtiden.
}